import { statusesConfig as shelfStatusesConfig } from '../shelf-management';

export const flagsConfig = {
  ...shelfStatusesConfig,
};
